import { ReactNode } from "react"
import { css, keyframes } from "@emotion/css"

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateX(10%);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`
const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translateX(0);
  }
  to {
    opacity: 0;
    transform: translateX(10%);
  }
`
export default function FadeIn({
  duration = 300,
  delay = 0,
  children,
  isFadingOut,
}: {
  duration?: number
  delay?: number
  children: ReactNode
  isFadingOut?: boolean
}) {
  return (
    <div
      style={{
        animationDuration: duration + "ms",
        animationDelay: delay + "ms",
      }}
      className={isFadingOut ? styles.wrapperOut : styles.wrapperIn}
    >
      {children}
    </div>
  )
}

const styles = {
  wrapperIn: css`
    @media (prefers-reduced-motion: no-preference) {
      animation-name: ${fadeIn};
      animation-fill-mode: backwards;
    }
  `,
  wrapperOut: css`
    @media (prefers-reduced-motion: no-preference) {
      animation-name: ${fadeOut};
      animation-fill-mode: backwards;
    }
  `,
}
